'use client';

import { useEffect } from 'react';
import { prefetchLocation } from '@src/v3/utils/location';

/**
 * Client component that prefetches user location on mount.
 * This warms up the location cache so that subsequent API calls
 * that need the origin parameter don't have to wait.
 *
 * Renders nothing - just triggers the prefetch as a side effect.
 */
const LocationPrefetch: React.FC = () => {
  useEffect(() => {
    prefetchLocation();
  }, []);

  return null;
};

export default LocationPrefetch;
